<div class="layout has-sidebar fixed-sidebar">
  <!---has-sidebar-->
  <app-menu-sidebar></app-menu-sidebar>
  <app-chat-gpt></app-chat-gpt>

  <div class="layout">
    <header class="">
      <app-header class="header row g-0"></app-header>
    </header>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
    <!-- <div class="overlay"></div> -->
  </div>
</div>
